/* eslint-disable max-len */
/**
@format
@flow
*/
import React from 'react';
import { ButtonPill as KrispyButtonPill } from '@krispy/buttons/web';
import type { IconType } from '@ziynx/flow-types/icons';

type LabelType = {
    text: string,
    size?: string,
    color?: string,
};

type ButtonColorConfig = {
    backgroundColor?: string,
    iconLeft?: string,
    iconRight?: string,
    text?: string,
}

export type Props = $ReadOnly<{|
  /**
   * Width of the Pill.
   */
   width?: string | number,

  /**
   * Pill label
   */
   label?: LabelType,

  /**
   * Left aligned icon
   */
   iconLeft?: IconType,

  /**
   * Right aligned icon
   */
   iconRight?: IconType,

  /**
   * Pill background color
   */
   backgroundColor?: string,

  /**
   * Hover color config
   */
   hoverConfig?: ButtonColorConfig,

   /**
    * Active color config
    */
   activeConfig?: ButtonColorConfig,

  /**
   * onClick
   */
   onClick?: (event: SyntheticEvent<HTMLButtonElement>) => any | Promise<any>;

  /**
   * Whether button is in inverted state
   */
   inverted?: boolean,

  /**
   * Whether button is disabled
   */
   disabled?: boolean,

   /**
    * When button is active
    */
    active?: boolean,
|}>;

const ButtonPill = (props: Props): React$Node => (
  <KrispyButtonPill {...props} />
);

export default ButtonPill;
